import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';


@Injectable()
export class FormUtil {

  public static checkFormValidations(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
      control.markAsDirty();
      if (control instanceof FormGroup) {
        this.checkFormValidations(control);
      }
    });
  }

  public static checkControlsValidations(formGroup: FormGroup, controlsName: string[]) {
    controlsName.forEach(name => {
      const control = formGroup.get(name);
      if (control.enabled) {
        control.markAsTouched({ onlySelf: true });
        control.markAsDirty();
      }
    });
  }

  public static disableForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      formGroup.get(field).disable({ emitEvent: false });
    });
  }

  public static enabledForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      formGroup.get(field).enable();
    });
  }

  public static setError(control: FormControl | AbstractControl, erro: ValidationErrors) {
    control.markAsTouched();
    control.setErrors(erro);
  }

  public static enabledControls(formGroup: FormGroup, controls: string[]) {
    controls.forEach(control => {
      if (formGroup.get(control)) {
        formGroup.get(control).enable();
      }
    });
  }

  public static disabledControls(formGroup: FormGroup, controls: string[]) {
    controls.forEach(control => {
      if (formGroup.get(control)) {
        formGroup.get(control).disable();
      }
    });
  }

  public static resetControls(formGroup: FormGroup, controls: string[]) {
    controls.forEach(control => {
      formGroup.get(control).reset();
    });
  }

  // Função que pegar os Validadores de um detarminando field
  public static bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach(valid => {
        validList.push(valid.validator);
      });

      return Validators.compose(validList);
    }

    return null;
  }

  public static getFormValues(formGroup: FormGroup) {
    const values = {};
    Object.keys(formGroup.controls).forEach(name => {
      if (formGroup.controls[name].value) {
        values[name] = formGroup.controls[name].value;
      }
    });

    return values;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/base/util/form.util.ts